<template xmlns:v-on="http://www.w3.org/1999/xhtml" xmlns:v-bind="http://www.w3.org/1999/xhtml">
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-name">
                <h2 id="benefitHeader">
                    {{pageTitle}}
                    <button type="button" class="btn btn-primary pull-right" v-on:click.prevent="buttonBack">Back</button>
                </h2>
            </div>
            <!--page content-->
            <div class="admin-page-content CustomPadTop0">
                <div class="card-body">
                    <form id="changeProfile">

                        <!--User Details-->
                        <template v-if="$route.path.indexOf('/adduserlocation') >= 0">
                            <div class="row">
                                <!--First Name-->
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="firstName">First Name<span class="text-danger">*</span></label>
                                        <input v-model="firstName" type="text" class="form-control" id="firstName" placeholder="Enter First Name">
                                        <div class="text-danger">{{firstNameError}}</div>
                                    </div>
                                </div>
                                <!--Last Name-->
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="lastName">Last Name<span class="text-danger">*</span></label>
                                        <input v-model="lastName" type="text" class="form-control" id="lastName" placeholder="Enter Last Name">
                                        <div class="text-danger">{{lastNameError}}</div>
                                    </div>
                                </div>
                                <!--User Email-->
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="email">Email<span class="text-danger">*</span></label>
                                        <input v-model="email" type="text" class="form-control" id="email" placeholder="Enter Email">
                                        <div class="text-danger">{{emailError}}</div>
                                    </div>
                                </div>
                                <div class="clearfix"></div>
                                <!--Location-->
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="selectedLocation">Select Primary Location<span class="text-danger">*</span></label>
                                        <v-select v-model="selectedLocationWhileAdd" name="location" placeholder="Type location here"
                                                  label="location_name"
                                                  id="selectedLocationWhileAdd"
                                                  @input="onchangeLocation()"
                                                  :options="locationOptions" class="" >
                                        </v-select>
                                        <font class="text-danger">{{locationWhileAddError}}</font>
                                    </div>
                                </div>

                                <!--Will Location -->
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="selectedWillCallLocation">Select Secondary Location</label>
                                        <v-select v-model="selectedWillCallLocationWhileAdd" name="willcalllocation" placeholder="Type location here"
                                                  label="location_name"
                                                  id="selectedWillCallLocationWhileAdd"
                                                  :options="locationOptions" class="" >
                                        </v-select>
                                        <font class="text-danger">{{locationWhileAddError}}</font>
                                    </div>
                                </div>

                                <!--Role-->
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="selecteRole">Select Role<span class="text-danger">*</span></label>
                                        <v-select v-model="selectedRoleWhileAdd" name="role" placeholder="Type Role here"
                                                  label="role_name"
                                                  id="selectedRoleWhileAdd"
                                                  @input="onchangeRole()"
                                                  :options="roleOptions" class="" >
                                        </v-select>
                                        <font class="text-danger">{{roleWhileAddError}}</font>
                                    </div>
                                </div>
                                <div class="clearfix"></div>
                                <!--Allow Multiple Login-->
                                <div class="col-md-6 CustomAML">
                                    <div class="form-group">
                                        <div class="checkbox">
                                            <label><input v-model="allowMultipleLoginWhileAdd" type="checkbox" value="">Allow Multiple Login</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="clearfix"></div>

                                <!--Buttons-->
                                <div class="row clearfix"></div>
                                <div class="col-md-12 input-group mt-3">
                                    <div class="button-demo">
                                        <input id="addUser" type="button" value="Add" class="btn btn-primary" v-on:click.prevent="addUser()">
                                        <input id="backButtonUser" type="button" value="Cancel" class="btn btn-primary" v-on:click.prevent="buttonBack">
                                    </div>
                                </div>
                            </div>
                        </template>

                        <template v-if="$route.path.indexOf('/updateuserlocation') >= 0">
                            <!--First Name-->
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="firstNameWhileUpdate">First Name<span class="text-danger">*</span></label>
                                        <input v-model="firstNameWhileUpdate" type="text" class="form-control" id="firstNameWhileUpdate" placeholder="Enter First Name">
                                        <div class="text-danger">{{firstNameWhileUpdateError}}</div>
                                    </div>
                                </div>
                                <!--Last Name-->
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="lastNameWhileUpdate">Last Name<span class="text-danger">*</span></label>
                                        <input v-model="lastNameWhileUpdate" type="text" class="form-control" id="lastNameWhileUpdate" placeholder="Enter Last Name">
                                        <div class="text-danger">{{lastNameWhileUpdateError}}</div>
                                    </div>
                                </div>
                                <!--User Email-->
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="emailWhileUpdate">Email<span class="text-danger">*</span></label>
                                        <input v-model="emailWhileUpdate" type="text" class="form-control" id="emailWhileUpdate" placeholder="Enter Email">
                                        <div class="text-danger">{{emailWhileUpdateError}}</div>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="selectedLocation">Select Primary Location<span class="text-danger">*</span></label>
                                        <v-select v-model="selectedLocation" name="location" placeholder="Type location here"
                                                  label="location_name"
                                                  id="selectedLocation"
                                                  @input="onchangeLocation()"
                                                  :options="locationOptions" class="" >
                                        </v-select>
                                        <font class="text-danger">{{locationError}}</font>
                                    </div>
                                </div>

                                <!--Will Location -->
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="selectedWillCallLocation">Select Secondary Location</label>
                                        <v-select v-model="selectedWillCallLocation" name="willcalllocation" placeholder="Type location here"
                                                  label="location_name"
                                                  id="selectedWillCallLocation"
                                                  :options="locationOptions" class="" >
                                        </v-select>
                                        <font class="text-danger">{{locationWhileAddError}}</font>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="selectedRole">Select Role<span class="text-danger">*</span></label>
                                        <v-select v-model="selectedRole" name="role" placeholder="Type role here"
                                                  label="role_name"
                                                  id="selectedRole"
                                                  @input="onchangeRole()"
                                                  :options="roleOptions" class="" >
                                        </v-select>
                                        <font class="text-danger">{{roleError}}</font>
                                    </div>
                                </div>
                                <div class="clearfix"></div>
                                <!--Allow Multiple Login-->
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <div class="checkbox">
                                            <label><input class="updateCheckbox" v-model="allowMultipleLoginWhileUpdate" type="checkbox" value="">Allow Multiple Login</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="clearfix"></div>
                                <!--Buttons-->
                                <div class="col-md-12 input-group mt-3">
                                    <div class="button-demo">

                                        <input id="addLocation" type="button" value="Update" class="btn btn-primary" v-on:click.prevent="updateUserDetails()">
                                        <input id="backButtonLocation" type="button" value="Cancel" class="btn btn-primary" v-on:click.prevent="buttonBack">
                                    </div>
                                </div>
                            </div>
                        </template>

                        <div class="clearfix"></div>

                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <!--<button @click="bind()">Bind</button>-->
                        </div>
                        <br/>
                        <!--Error Alert-->
                        <div class="row clearfix" >
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="alert alert-danger" id="alertError">
                                    <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                    <strong id="errorMsg" class="error"></strong>
                                </div>
                            </div>
                        </div>
                        <div class="clearfix"></div>

                        <!--Buttons-->
                        <!--<div class="row clearfix"></div>-->
                        <!--<div class="button-demo">-->
                        <!--<input id="addBenifitBtn" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addUpdateUserLocation ()">-->
                        <!--<input id="addAndContinueBenifitBtn" type="submit" value="Save and Continue" class="btn btn-primary" v-on:click.prevent="addUpdateUserLocation (flag='Save and Continue')">-->
                        <!--&lt;!&ndash;<input id="addMedia" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addUpdateUserLocation ()"></input>&ndash;&gt;-->
                        <!--<input id="CancelBenifit" type="submit" value="Cancel" class="btn btn-primary" v-on:click.prevent="buttonBack">-->
                        <!--</div>-->

                        <!--page content-->
                        <app-footer></app-footer>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    var self;
    import vSelect from 'vue-select';
    import Vue from 'vue';
    import {HTTP} from '../http-common';
    import FrontFooter from '@/components/FrontFooter';
    import {commonMixins} from '../mixins/commonMixins';


    export default {
        name: 'AddStationLocation',
        props: [''],
        mixins: [commonMixins],
        components: {
            'v-select': vSelect,
            'app-footer':FrontFooter,
        },
        data() {
            return {
                email:'',
                selectedLocation:'',
                selectedWillCallLocation: '',
                selectedLocationWhileAdd : '',
                selectedWillCallLocationWhileAdd : '',
                locationOptions:[],
                firstName : '',
                lastName : '',
                firstNameWhileUpdate : '',
                lastNameWhileUpdate : '',
                emailWhileUpdate : '',
                // Frontend Error
                emailError : '',
                locationError : '',
                willCallLocationError : '',
                firstNameError : '',
                lastNameError : '',
                locationWhileAddError : '',
                //willCallLocationWhileAddError : '',
                firstNameWhileUpdateError : '',
                lastNameWhileUpdateError : '',
                emailWhileUpdateError : '',
                firstLoad : true,
                allowMultipleLoginWhileAdd : 0,
                allowMultipleLoginWhileUpdate : 0,

                roleOptions : [],
                selectedRoleWhileAdd : '',
                roleWhileAddError : '',
                selectedRole : '',
                roleError : '',

//                BackEnd Error
                backendErrors: [],
                pageTitle : 'Add User'
            }
        },
        mounted: function () {
            self = this;
            $("#email").on('keyup', function () {
                self.emailError = '';
            });
            $("#firstName").on('keyup', function () {
                self.firstNameError = '';
            });
            $("#lastName").on('keyup', function () {
                self.lastNameError = '';
            });
            $("#selectedLocationWhileAdd").on('keyup', function () {
                self.locationWhileAddError = '';
            });
            $("#firstNameWhileUpdate").on('keyup', function () {
                self.firstNameWhileUpdateError = '';
            });
            $("#lastNameWhileUpdate").on('keyup', function () {
                self.lastNameWhileUpdateError = '';
            });
            $("#emailWhileUpdate").on('keyup', function () {
                self.emailWhileUpdateError = '';
            });
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[1] == 'updateuserlocation') {
                if (segments[2]) {
                    self.loadUserLocationData();
                    self.pageTitle = "Edit User";
                }
            }
            $(document).ready(function(){
                $('input[type="checkbox"]').click(function(){
                    if($(this).prop("checked") == true){
                        self.allowMultipleLoginWhileAdd = 1;
                        self.allowMultipleLoginWhileUpdate = 1;
                    }
                    else if($(this).prop("checked") == false){
                        self.allowMultipleLoginWhileAdd = 0;
                        self.allowMultipleLoginWhileUpdate = 0;
                    }
                });
            });
            self.loadLocations();
            self.loadRole();
            $("#alertError").hide();
        },
        watch: {
            email : function (email) {
                let self = this;
                if (email.length > 3) {
                    if (!self.validEmail(self.email)) {
                        self.emailError = 'Please Enter Valid Email';
                    } else {
                        self.checkUserInSSO();
                    }
                }
            },
            emailWhileUpdate : function (emailWhileUpdate) {
                let self = this;
                if (emailWhileUpdate.length > 3) {
                    if (!self.validEmail(self.emailWhileUpdate)) {
                        self.emailWhileUpdateError = 'Please Enter Valid Email';
                    } else {
                        self.checkUserInSSO();
                    }
                }
            }

        },
        methods: {
            onchangeRole : function () {
                self.roleWhileAddError = '';
                self.roleError = '';
            },
            onchangeLocation : function () {
                self.locationError = '';
                self.locationWhileAddError = '';
            },
            buttonBack : function () {
                self.$router.push('/listuserlocation');
            },
            checkUserInSSO : function () {
                let self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                };
                let data = {
                    email : self.email,
                    emailWhileUpdate : self.emailWhileUpdate,
                }
                HTTP.post('user/checkinsso', data, config)
                    .then(function (response) {
                        if (response.data.code == 200) {
                            self.showSAlert(response.data.content, self.saOpTypes.INFO, function() {
                                console.log("here");
                            });
                        }
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    })
            },
            loadUserLocationData() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var data = {
                    user_id: segments[2],
                };
                HTTP.post("/user/getuserdetails/" + segments[2], data, config)
                    .then(function (response) {
                        self.selectedLocation = {
                            location_id : response.data.content.location_id,
                            location_name : response.data.content.location_name,
                            ip_address : null,
                            printer_series : null,
                            printer_version : null,
                        };
                        self.selectedWillCallLocation = {
                            location_id : response.data.content.will_call_location_id,
                            location_name : response.data.content.will_call_location_name,
                            ip_address : null,
                            printer_series : null,
                            printer_version : null,
                        };
                        
                        self.emailWhileUpdate = response.data.content.email;
                        self.firstNameWhileUpdate = response.data.content.first_name;
                        self.lastNameWhileUpdate = response.data.content.last_name;
                        self.selectedRole = {
                            role_id : response.data.content.role_id,
                            role_name : response.data.content.role_name,
                        }
                        self.allowMultipleLoginWhileUpdate = response.data.content.is_multiple_login_allow;
                        if (self.allowMultipleLoginWhileUpdate === 1) {
                            // updateCheckbox
                            $('.updateCheckbox').prop('checked', true);
                        } else if (self.allowMultipleLoginWhileUpdate === 0) {
                            $('.updateCheckbox').prop('checked', false);
                        }
                    })
                    .catch(function (err) {
                        console.log(err);
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                self.$router.push("/login");
                                //EventBus.$emit("logged-in", true, "", "");
                            }
                            self.error = err.response.data.message;
                        }
                    });
            },

            checkForm: function () {
                var checked = true;
                if (!self.firstName) {
                    self.firstNameError = "First Name Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.lastName) {
                    self.lastNameError = "Last Name Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.selectedLocationWhileAdd) {
                    self.locationWhileAddError = "Location Required";
                    if (checked) {
                        checked = false;
                    }
                }

                // Commenting below as it is not mandatory to select Will Call Location
                /*
                if (!self.selectedWillCallLocationWhileAdd) {
                    self.willCallLocationWhileAddError = "Will Call Location Required";
                    if (checked) {
                        checked = false;
                    }
                }
                */

                if (!self.selectedRoleWhileAdd) {
                    self.roleWhileAddError = "Role Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.email) {
                    self.emailError = "Email Required";
                    if (checked) {
                        checked = false;
                    }
                } else if (!self.validEmail(self.email)) {
                    self.emailError = 'Please Enter Valid Email';
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            validEmail: function (email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            addUser : function() {
                self.checkForm();
                if (self.checkForm()) {
                    if (self.allowMultipleLoginWhileAdd == true) {
                        self.allowMultipleLoginWhileAdd = 1;
                    } else if (self.allowMultipleLoginWhileAdd == false) {
                        self.allowMultipleLoginWhileAdd = 0;
                    }
                   
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };

                    var data = {
                        email: self.email,
                        first_name : self.firstName,
                        last_name : self.lastName,
                        location_id_while_add : self.selectedLocationWhileAdd.location_id,
                        will_call_location_id_while_add : self.selectedWillCallLocationWhileAdd.location_id,
                        role_id_while_add : self.selectedRoleWhileAdd.role_id,
                        allow_multiple_login_while_add : self.allowMultipleLoginWhileAdd,
                    };

                    HTTP.post("/user/adduser", data, config)
                        .then(function (response) {
                            if (response.data.status == "success") {
                                $("#errorMsg").html(response.data.message);
                                $(".alert-danger").show()
                                setTimeout(function () {
                                    $(".alert-danger").hide();
                                }, 5000);
                                setTimeout(function () {
                                    $("#addUser").val("Add");
                                    $("#addUser").prop("disabled", false);
                                    $("#backButtonUser").val("Cancel ");
                                    $("#backButtonUser").prop("disabled", false);
                                    self.buttonBack();
                                }, 3000);
                            } else {
                                $("#errorMsg").html(response.data.message);
                                $(".alert-danger").show()
                                setTimeout(function () {
                                    $(".alert-danger").hide();
                                }, 5000);
                            }

                        })
                        .catch(function (err) {
                            console.log(err)
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
                }
            },
            checkLocationForm : function () {
                var checked = true;
                if (!self.selectedLocation) {
                    self.locationError = "Location Required";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.selectedLocation.location_id === null) {
                    self.locationError = "Location Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.selectedRole) {
                    self.roleError = "Role Required";
                    if (checked) {
                        checked = false;
                    }
                } else if (JSON.stringify(self.selectedRole) == "{}") {
                    self.roleError = "Role Required";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.selectedRole.role_id === null) {
                    self.roleError = "Role Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.firstNameWhileUpdate) {
                    self.firstNameWhileUpdateError = "First Name Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.lastNameWhileUpdate) {
                    self.lastNameWhileUpdateError = "Last Name Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.emailWhileUpdate) {
                    self.emailWhileUpdateError = "Email Required";
                    if (checked) {
                        checked = false;
                    }
                } else if (!self.validEmail(self.emailWhileUpdate)) {
                    self.emailWhileUpdateError = 'Please Enter Valid Email';
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            updateUserDetails : function () {
                if (self.checkLocationForm()) {
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    $("#addLocation").val("Update");
                    $("#addLocation").prop("disabled", true);
                    $("#backButtonLocation").val("Cancel");
                    $("#backButtonLocation").prop("disabled", true);
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };
                    let loginUserId = JSON.parse(localStorage.getItem("user_obj")).id;

                    let willCallLocationId = null
                    if(self.selectedWillCallLocation != null) {
                        willCallLocationId = self.selectedWillCallLocation.location_id;
                    }

                    var data = {
                        first_name : self.firstNameWhileUpdate,
                        last_name : self.lastNameWhileUpdate,
                        email: self.emailWhileUpdate,
                        location_id : self.selectedLocation.location_id,
                        will_call_location_id : willCallLocationId,
                        role_id : self.selectedRole.role_id,
                        login_userId : loginUserId,
                        user_id : segments[2],
                        allow_muliple_login_while_update : self.allowMultipleLoginWhileUpdate,
                    };

                    HTTP.post("/user/updateuser", data, config)
                        .then(function (response) {
                            if (response.data.status == "success") {
                                var path = window.location.pathname;
                                var segments = path.split("/");
                                var userObj = JSON.parse(localStorage.getItem("user_obj"));
                                let userId = userObj.id;
                                if (segments[2] == userId) {

                                }
                                $("#errorMsg").html(response.data.content);
                                $(".alert-danger").show();
                                setTimeout(function () {
                                    $(".alert-danger").hide();
                                }, 5000);
                                setTimeout(function () {
                                    $("#addLocation").val("Update");
                                    $("#addLocation").prop("disabled", false);
                                    $("#backButtonLocation").val("Cancel");
                                    $("#backButtonLocation").prop("disabled", false);
                                    self.buttonBack();
                                }, 3000);
                            } else {
                                $("#errorMsg").html(response.data.content);
                                $(".alert-danger").show();
                                setTimeout(function () {
                                    $(".alert-danger").hide();
                                }, 5000);
                            }
                        })
                        .catch(function (err) {
                            console.log(err)
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
                }
            },
            // addUpdateUserLocation (flag) {
            //     self.checkForm();
            //     if (self.checkForm()) {
            //         var path = window.location.pathname;
            //         var segments = path.split("/");
            //         var config = {
            //             headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
            //         };
            //
            //         if (segments[1] == 'updateuserlocation') {
            //             if (segments[2]) {
            //                 var data = {
            //                     email : self.email,
            //                     location_id : self.selectedLocation.location_id,
            //                     user_id: segments[2],
            //                 };
            //                 $("#addBenifitBtn").val("Updating ...");
            //                 $("#addBenifitBtn").prop("disabled", true);
            //                 // $("#addAndContinueCaseBtn").prop('disabled',true);
            //                 $("#CancelBenifit").prop("disabled", true);
            //             } else {
            //                 if (flag == "Save and Continue") {
            //                     $("#addAndContinueBenifitBtn").val("Saving ...");
            //                     $("#addAndContinueBenifitBtn").prop("disabled", true);
            //                     $("#addBenifitBtn").prop("disabled", true);
            //                     $("#CancelBenifit").prop("disabled", true);
            //                 } else {
            //                     $("#addBenifitBtn").val("Saving ...");
            //                     $("#addBenifitBtn").prop("disabled", true);
            //                     $("#addAndContinueBenifitBtn").prop("disabled", true);
            //                     $("#CancelBenifit").prop("disabled", true);
            //                 }
            //             }
            //         } else {
            //             var data = {
            //                 email : self.email,
            //             };
            //             if (flag == "Save and Continue") {
            //                 $("#addAndContinueBenifitBtn").val("Saving ...");
            //                 $("#addAndContinueBenifitBtn").prop("disabled", true);
            //                 $("#addBenifitBtn").prop("disabled", true);
            //                 $("#CancelBenifit").prop("disabled", true);
            //             } else {
            //                 $("#addBenifitBtn").val("Saving ...");
            //                 $("#addBenifitBtn").prop("disabled", true);
            //                 $("#addAndContinueBenifitBtn").prop("disabled", true);
            //                 $("#CancelBenifit").prop("disabled", true);
            //             }
            //         }
            //
            //         HTTP.post("/checkuserinsso", data, config)
            //             .then(function (response) {
            //                 if (segments[1] == 'updateuserlocation') {
            //                     if (segments[2]) {
            //                         $("#addBenifitBtn").val("Update");
            //                         $("#addBenifitBtn").prop("disabled", false);
            //                         $("#CancelBenifit").prop("disabled", false);
            //                     } else {
            //                         if (flag == "Save and Continue") {
            //                             $("#addAndContinueBenifitBtn").val("Save and Continue");
            //                             $("#addAndContinueBenifitBtn").prop("disabled", false);
            //                             $("#addBenifitBtn").prop("disabled", false);
            //                             $("#CancelBenifit").prop("disabled", false);
            //                         } else {
            //                             $("#addBenifitBtn").val("Save");
            //                             $("#addBenifitBtn").prop("disabled", false);
            //                             $("#addAndContinueBenifitBtn").prop("disabled", false);
            //                             $("#CancelBenifit").prop("disabled", false);
            //                         }
            //                     }
            //                 } else {
            //                     if (flag == "Save and Continue") {
            //                         $("#addAndContinueBenifitBtn").val("Save and Continue");
            //                         $("#addAndContinueBenifitBtn").prop("disabled", false);
            //                         $("#addBenifitBtn").prop("disabled", false);
            //                         $("#CancelBenifit").prop("disabled", false);
            //                     } else {
            //                         $("#addBenifitBtn").val("Save");
            //                         $("#addBenifitBtn").prop("disabled", false);
            //                         $("#addAndContinueBenifitBtn").prop("disabled", false);
            //                         $("#CancelBenifit").prop("disabled", false);
            //                     }
            //                 }
            //
            //                 if (response.data.status == "success") {
            //                     $("#errorMsg").html(response.data.content);
            //                     $(".alert-danger").removeClass("hide");
            //                     $(".alert-danger").addClass("show");
            //                     if (flag == "Save and Continue") {
            //                         self.email = '';
            //                         setTimeout(function () {
            //                             $(".alert-danger").removeClass("show");
            //                             $(".alert-danger").addClass("hide");
            //                         }, 3000);
            //                     } else {
            //                         setTimeout(function () {
            //                             $(".alert-danger").removeClass("show");
            //                             $(".alert-danger").addClass("hide");
            //                             self.buttonBack();
            //                         }, 3000);
            //                     }
            //                 } else {
            //                     $("#alertError").show();
            //                     if (response.data.content.length > 0) {
            //                         var err = "";
            //                         for (var i = 0; i < response.data.content.length; i++) {
            //                             err += response.data.content[i];
            //                             // err += response.data.content[i] + "<br>";
            //                         }
            //                         $("#errorMsg").html(err);
            //                         $(".alert-danger").removeClass("hide");
            //                         $(".alert-danger").addClass("show");
            //                     }
            //                     setTimeout(function () {
            //                         $(".alert-danger").removeClass("show");
            //                         $(".alert-danger").addClass("hide");
            //                     }, 5000);
            //                 }
            //             })
            //             .catch(function (err) {
            //                 if (segments[1] == 'updateuserlocation') {
            //                     if (segments[2]) {
            //                         $("#addBenifitBtn").val("Update");
            //                         $("#addBenifitBtn").prop("disabled", false);
            //                         $("#CancelBenifit").prop("disabled", false);
            //                         $("#errorMsg").html(err.response.data.message);
            //                         $(".alert-danger").removeClass("hide");
            //                         $(".alert-danger").addClass("show");
            //                         setTimeout(function () {
            //                             $(".alert-danger").removeClass("show");
            //                             $(".alert-danger").addClass("hide");
            //                         }, 5000);
            //                     } else {
            //                         if (flag == "Save and Continue") {
            //                             $("#addAndContinueBenifitBtn").prop("disabled", false);
            //                             $("#addAndContinueBenifitBtn").val("Save and Continue");
            //                             $("#addBenifitBtn").prop("disabled", false);
            //                             $("#CancelBenifit").prop("disabled", false);
            //                             $("#errorMsg").html(err.response.data.message);
            //                             $(".alert-danger").removeClass("hide");
            //                             $(".alert-danger").addClass("show");
            //                             self.email = '';
            //                             setTimeout(function () {
            //                                 $(".alert-danger").removeClass("show");
            //                                 $(".alert-danger").addClass("hide");
            //                             }, 5000);
            //                         } else {
            //                             $("#addBenifitBtn").val("Save");
            //                             $("#addBenifitBtn").prop("disabled", false);
            //                             $("#addAndContinueBenifitBtn").prop("disabled", true);
            //                             $("#CancelBenifit").prop("disabled", false);
            //                             $("#errorMsg").html(err.response.data.message);
            //                             $(".alert-danger").removeClass("hide");
            //                             $(".alert-danger").addClass("show");
            //                             setTimeout(function () {
            //                                 $(".alert-danger").removeClass("show");
            //                                 $(".alert-danger").addClass("hide");
            //                             }, 5000);
            //                         }
            //
            //                         if (err.response.status == 0) {
            //                             self.errorMsg = "Remote server can not be reachable";
            //                         } else {
            //                             //redirect to login page if user not authenticated
            //                             if (err.response.status == 401) {
            //                                 //clear previous data
            //                                 localStorage.removeItem("user_obj");
            //                                 localStorage.removeItem("api_token");
            //                                 localStorage.removeItem("profile_image");
            //                                 //EventBus.$emit("logged-in", true, "", "");
            //                                 self.$router.push("/login");
            //                             }
            //                             $("#errorMsg").html(err.response.data.message);
            //                             $(".alert-danger").removeClass("hide");
            //                             $(".alert-danger").addClass("show");
            //                             setTimeout(function () {
            //                                 $(".alert-danger").removeClass("show");
            //                                 $(".alert-danger").addClass("hide");
            //                             }, 5000);
            //                         }
            //                     }
            //                 } else {
            //                     if (flag == "Save and Continue") {
            //                         $("#addAndContinueBenifitBtn").prop("disabled", false);
            //                         $("#addAndContinueBenifitBtn").val("Save and Continue");
            //                         $("#addBenifitBtn").prop("disabled", false);
            //                         $("#CancelBenifit").prop("disabled", false);
            //                         $("#errorMsg").html(err.response.data.message);
            //                         $(".alert-danger").removeClass("hide");
            //                         $(".alert-danger").addClass("show");
            //                         self.email = '';
            //                         setTimeout(function () {
            //                             $(".alert-danger").removeClass("show");
            //                             $(".alert-danger").addClass("hide");
            //                         }, 5000);
            //                     } else {
            //                         $("#addBenifitBtn").val("Save");
            //                         $("#addBenifitBtn").prop("disabled", false);
            //                         $("#addAndContinueBenifitBtn").prop("disabled", true);
            //                         $("#CancelBenifit").prop("disabled", false);
            //                         $("#errorMsg").html(err.response.data.message);
            //                         $(".alert-danger").removeClass("hide");
            //                         $(".alert-danger").addClass("show");
            //                         setTimeout(function () {
            //                             $(".alert-danger").removeClass("show");
            //                             $(".alert-danger").addClass("hide");
            //                         }, 5000);
            //                     }
            //
            //                     if (err.response.status == 0) {
            //                         self.errorMsg = "Remote server can not be reachable";
            //                     } else {
            //                         //redirect to login page if user not authenticated
            //                         if (err.response.status == 401) {
            //                             //clear previous data
            //                             localStorage.removeItem("user_obj");
            //                             localStorage.removeItem("api_token");
            //                             localStorage.removeItem("profile_image");
            //                             //EventBus.$emit("logged-in", true, "", "");
            //                             self.$router.push("/login");
            //                         }
            //                         $("#errorMsg").html(err.response.data.message);
            //                         $(".alert-danger").removeClass("hide");
            //                         $(".alert-danger").addClass("show");
            //                         setTimeout(function () {
            //                             $(".alert-danger").removeClass("show");
            //                             $(".alert-danger").addClass("hide");
            //                         }, 5000);
            //                     }
            //                 }
            //             });
            //     }
            // },

        }
    }
</script>

<style>
    .disabled {
        pointer-events:none;
        color: #bfcbd9;
        cursor: not-allowed;
        background-image: none;
        background-color: #eef1f6;
        border-color: #d1dbe5;
    }
</style>



// WEBPACK FOOTER //
// src/components/AddUserLocation.vue